export default "__VITE_ASSET__t9FUCRck5mI3Q3fZmXY_eg__"